export default "__VITE_ASSET__DXl3zpKq__"